/* ==========================================================================
   Noveliya — PDP behaviour
   Two jobs, no library:
     1. Sticky ATC bar — shows once the real buy box scrolls off the top
     2. ATC button label — keeps price in sync with the selected variant
   Swatch hover hint lives in noveliya-swatches.js.
   Gallery behaviour lives in noveliya-gallery.js.
   Dawn's product-info.js owns variant fetch, URL and price swap.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  /* ── Sticky ATC bar ─────────────────────────────────────────────────────
     Shows once the real buy box has scrolled off the top of the viewport.
     The bar never owns a form — it forwards the click to the real submit
     button so Dawn keeps ownership of loading state, errors and the drawer.
     ----------------------------------------------------------------------- */
  document.querySelectorAll('.nv-sticky').forEach((bar) => {
    const sectionId   = bar.dataset.section;
    const realButton  = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!realButton) return;

    const stickyButton = bar.querySelector('[data-nv-sticky-submit]');
    const priceEl      = bar.querySelector('[data-nv-sticky-price]');
    const variantEl    = bar.querySelector('[data-nv-sticky-variant]');

    stickyButton?.addEventListener('click', () => realButton.click());

    /* Visibility — passive scroll listener throttled with rAF rather than an
       IntersectionObserver. IO reports nothing in some embedded/automated
       contexts; a rect check runs everywhere and costs nothing at one call per
       animation frame. */
    let ticking = false;

    const sync = () => {
      ticking = false;
      const scrolledPast = realButton.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('is-visible') === scrolledPast) return;
      bar.classList.toggle('is-visible', scrolledPast);
      bar.setAttribute('aria-hidden', String(!scrolledPast));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    sync();

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;

      const livePrice = document.querySelector(`#price-${sectionId} .nv-price__now`);
      if (livePrice && priceEl) priceEl.textContent = livePrice.textContent.trim();
      if (variantEl && data.variant?.title) variantEl.textContent = data.variant.title;

      if (!stickyButton) return;
      const unavailable = !data.variant?.available;
      stickyButton.toggleAttribute('disabled', unavailable);
      stickyButton.textContent = unavailable ? 'Uitverkocht' : 'Koop';
    });
  });

  /* ── ATC button label stays in sync with the selected variant ───────────
     Trap: Dawn's productForm.toggleSubmitButton() overwrites the button span
     with window.variantStrings.addToCart on every variant change — that wipes
     our price out of the label. It runs *before* variantChange is published,
     so we rewrite the label here, after Dawn is done.
     ----------------------------------------------------------------------- */
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const button  = document.getElementById(`ProductSubmitButton-${data.sectionId}`);
    const priceEl = document.querySelector(`#price-${data.sectionId} .nv-price__now`);
    if (!button || !priceEl) return;

    // Sold out / unavailable: leave Dawn's message in place.
    if (!data.variant?.available || button.hasAttribute('disabled')) return;

    const label = button.querySelector('span');
    if (!label) return;

    label.textContent = '';
    label.append(document.createTextNode('In winkelwagen — '));

    const price = document.createElement('span');
    price.className = 'nv-atc__price';
    price.textContent = priceEl.textContent.trim();
    label.append(price);
  });
});
